
/****************************************************************
 * Vue
 ****************************************************************/
import { defineComponent } from "vue";
import UserLogin from "@/components/UserLogin.vue";

/****************************************************************
 * Firebase
 ****************************************************************/
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyChvFsnJVGrX-oNlyw0TS1_PRQ5JuNcx2k",
  authDomain: "study-record-app.firebaseapp.com",
  projectId: "study-record-app",
  storageBucket: "study-record-app.appspot.com",
  messagingSenderId: "170318537678",
  appId: "1:170318537678:web:d448589f6caa31f5fa019f",
  measurementId: "G-D8NJ5N5F07",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const analytics = getAnalytics(app);

export default defineComponent({
  name: "HomeView",
  components: {
    UserLogin,
  },
});
